// Registers the bundled `public/fonts/*` faces at runtime on web by linking the generated
// `/fonts/split.css` — the ONE stylesheet that declares every `Han Composite` face (unicode-range
// chunks for the heavy faces, single files for the Latin weights; see `web-font-stylesheet-href.ts`).
//
// Why a <link> appended at runtime, rather than @font-face in +html.tsx or global.css?
//   - A bare <style> in +html.tsx does NOT survive React Native Web hydration: RNW prepends its
//     own <style id="react-native-stylesheet"> to <head> and the adjacent server-rendered
//     dangerouslySetInnerHTML <style> gets dropped, so the family silently fell back to a system
//     font.
//   - Putting @font-face in global.css breaks the Metro build: Metro tries to resolve the
//     `url("/fonts/...")` references as on-disk modules and fails ("Can't resolve
//     '/fonts/…'"). Those paths are runtime HTTP routes served from public/, not bundler modules.
//
// Appending a <link> after RNW has finished its head reconciliation sidesteps both. The
// server-rendered head links the same stylesheet (`root-html.tsx`), so whichever lands first wins
// and the other is a no-op — this is idempotent across Fast Refresh.
//
// Native (app.config.ts -> expo-font + expo-font-fallback) consumes the sibling `.ttf` faces and
// applies `Han Composite` as the app-wide default family; see register-fonts.cts.

import { WEB_FONT_STYLESHEET_HREF } from "#web-font-stylesheet-href";

const STYLESHEET_LINK_ID = "han-fonts-stylesheet";

function registerWebFonts() {
  if (typeof document === "undefined") {
    return;
  }
  // Idempotent: a re-import during Fast Refresh must not double-link the sheet, and the SSR head
  // may already carry it.
  if (document.querySelector(`link[href="${WEB_FONT_STYLESHEET_HREF}"]`) !== null) {
    return;
  }
  const link = document.createElement("link");
  link.id = STYLESHEET_LINK_ID;
  link.rel = "stylesheet";
  link.href = WEB_FONT_STYLESHEET_HREF;
  document.head.append(link);
}

// eslint-disable-next-line no-top/no-top-level-side-effects -- imperative stylesheet registration at import; see file header
registerWebFonts();

export {};
